import create from "zustand";

const useActiveClientIdStore = create((set: any) => ({
    activeClientId: 0,
    setActiveClientId: (data: number) => set(() => ({ activeClientId: data })),
}));

export { useActiveClientIdStore };
